import React from 'react';
import { Space } from 'antd';
import { SkiTouringFilters as SkiTouringFiltersType } from '../../types/index';
import {
  SKI_RATING_SYSTEM,
  SKI_EXPOSITION_SYSTEM,
  SKI_GLOBAL_RATING_SYSTEM,
  SKI_PUNCTUAL_RATING_SYSTEM,
} from '../../constants/skiRatingSystems';
import LabeledRangeSlider from './filter-components/LabelRangedSlider';
import LabeledSlider from './filter-components/LabeledSlider';
import WindRose from './filter-components/WindRose';

interface SkiTouringFiltersProps {
  filters: SkiTouringFiltersType;
  onChange: (filters: SkiTouringFiltersType) => void;
  routes: unknown[];
}

export const SkiTouringFilters: React.FC<SkiTouringFiltersProps> = ({
  filters,
  onChange,
  routes
}) => {
  const getAvailableRatings = (ratingType: string): string[] => {
    return ratingType === 'skiRating' ? [...SKI_RATING_SYSTEM] :
      ratingType === 'skiExposition' ? [...SKI_EXPOSITION_SYSTEM] :
        ratingType === 'skiGlobalRating' ? [...SKI_GLOBAL_RATING_SYSTEM] :
          [...SKI_PUNCTUAL_RATING_SYSTEM];
  };

  const updateFilter = (key: keyof SkiTouringFiltersType, value: unknown) => {
    const updatedFilters = {
      ...filters,
      [key]: value
    };
    onChange(updatedFilters);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="small">
      {/* Cotation ski */}
      <LabeledRangeSlider
        title="Cotation ski"
        emoji="⛷️"
        min={0}
        max={getAvailableRatings('skiRating').length - 1}
        values={[
          filters.skiRating?.min ?? 0,
          filters.skiRating?.max ?? (getAvailableRatings('skiRating').length - 1)
        ]}
        onChange={([min, max]) => updateFilter('skiRating', {
          min: min === 0 ? null : min,
          max: max === (getAvailableRatings('skiRating').length - 1) ? null : max
        })}
        labels={getAvailableRatings('skiRating')}
      />

      {/* Exposition ski */}
      <LabeledSlider
        title="Exposition ski"
        emoji="⚠️"
        min={0}
        max={getAvailableRatings('skiExposition').length - 1}
        value={filters.skiExposition?.max ?? (getAvailableRatings('skiExposition').length - 1)}
        onChange={(maxValue) => updateFilter('skiExposition', {
          min: null,
          max: maxValue === (getAvailableRatings('skiExposition').length - 1) ? null : maxValue
        })}
        labels={getAvailableRatings('skiExposition')}
      />
      {/* Dénivelé positif */}
      <LabeledRangeSlider
        title="Dénivelé"
        min={0}
        max={9000}
        values={[
          filters.heightDiffUp?.min ?? 0,
          filters.heightDiffUp?.max ?? 9000
        ]}
        onChange={([min, max]) => updateFilter('heightDiffUp', {
          min: min === 0 ? null : min,
          max: max === 9000 ? null : max
        })}
        unit="m"
        step={100}
      />

      {/* Altitude minimale */}
      <LabeledRangeSlider
        title="Altitude Départ"
        min={0}
        max={5000}
        values={[
          filters.elevationMin?.min ?? 0,
          filters.elevationMin?.max ?? 5000
        ]}
        onChange={([min, max]) => updateFilter('elevationMin', {
          min: min === 0 ? null : min,
          max: max === 5000 ? null : max
        })}
        unit="m"
        step={100}
      />

      {/* Orientation */}
      <WindRose
        title="Orientation"
        selectedOrientations={filters.orientations || []}
        onChange={(orientations) => updateFilter('orientations', orientations.length > 0 ? orientations : undefined)}
      />
    </Space>
  );
};

export default SkiTouringFilters;
